import { effect, Injector, untracked } from '@angular/core';

import { AuthSyncService } from '@zeusm/shared/session/auth';
import { UserStore } from '@zeusm/shared/session/user';

/**
 * Factory to initialize authentication by fetching user profile
 * This is needed for httponly cookies to work properly
 */
export function initAuthFactory(injector: Injector) {
  return () => {
    const userStore = injector.get(UserStore);

    // Initialize the auth sync service to set up cross-tab communication listeners
    void injector.get(AuthSyncService);

    // Return a promise that resolves when getMe completes
    return new Promise<void>(resolve => {
      // Create an effect to watch for getMe completion
      const cleanupEffect = effect(() => {
        const getMeSuccess = userStore.isGetMeSuccess();
        const getMeError = userStore.getMeError();

        // Only resolve when getMe has completed (either success or error)
        if (getMeSuccess !== null || getMeError !== null) {
          untracked(() => {
            cleanupEffect.destroy();
            resolve();
          });
        }
      });

      // Trigger the getMe call
      userStore.getMe();
    });
  };
}
